import { Dispatch, SetStateAction } from 'react';
import { SEOChildCareQualifications } from '@/__generated__/globalTypes';
import { MultiSelectPills } from '../../MultiSelectPills';

interface ChildCareProfessionalSkillsProps {
  childCareProfessionalSkillsList: SEOChildCareQualifications[];
  setChildCareProfessionalSkillsList: Dispatch<SetStateAction<SEOChildCareQualifications[]>>;
}

const ProfessionalSkills = ({
  childCareProfessionalSkillsList,
  setChildCareProfessionalSkillsList,
}: ChildCareProfessionalSkillsProps) => {
  const childCareProfessionalSkills = [
    { label: 'CPR training', value: SEOChildCareQualifications.CPR_TRAINING },
    { label: 'First Aid training', value: SEOChildCareQualifications.FIRST_AID_TRAINING },
    { label: 'Special needs care', value: SEOChildCareQualifications.SPECIAL_NEEDS_CARE },
  ];

  const handleOnChangeEvent = (values: SEOChildCareQualifications[]) => {
    setChildCareProfessionalSkillsList(values);
  };

  return (
    <MultiSelectPills
      sectionName="Professional skills"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={childCareProfessionalSkills}
      category="CHILD_CARE_PROFESSIONAL_SKILLS"
      selectedValues={childCareProfessionalSkillsList}
    />
  );
};

export { ProfessionalSkills };
